import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { AppShell } from "@components/shell/AppShell";
import { PlanFinder } from "@features/planFinder/PlanFinder";
import { CostPlan } from "@features/cost/CostPlan";
import { ProgramScreen } from "@features/program/ProgramScreen";
import { Workspace } from "@features/workspace/Workspace";
import { HolePlan } from "@features/holePlan/HolePlan";
import { Casing } from "@features/casing/Casing";
import { PlanTimeline } from "@features/timeline/PlanTimeline";
import { TrajectoryScreen } from "@features/trajectory/TrajectoryScreen";
import { Publish } from "@features/publish/Publish";
import { VersionsScreen } from "@features/versions/VersionsScreen";

/**
 * Oxbo-W sitemap — W0–W9 all built. Every route lives under the app shell.
 */
const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/finder" replace /> },
      { path: "finder", element: <PlanFinder /> }, // W0
      { path: "workspace", element: <Workspace /> }, // W1
      { path: "hole-plan", element: <HolePlan /> }, // W2
      { path: "casing", element: <Casing /> }, // W3
      { path: "cost", element: <CostPlan /> }, // W4
      { path: "program", element: <ProgramScreen /> }, // W5
      { path: "trajectory", element: <TrajectoryScreen /> }, // W6
      { path: "timeline", element: <PlanTimeline /> }, // W7
      { path: "versions", element: <VersionsScreen /> }, // W8
      { path: "publish", element: <Publish /> }, // W9
      { path: "*", element: <Navigate to="/finder" replace /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
